function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M1 3.92857V52.25C1 53.8674 2.31116 55.1786 3.92857 55.1786H24.4286C25.2373 55.1786 25.8929 54.523 25.8929 53.7143V41.2679C25.8929 39.6505 27.204 38.3393 28.8214 38.3393H40.5357C41.3444 38.3393 42 37.6837 42 36.875V3.92857C42 2.31117 40.6888 1 39.0714 1H3.92857C2.31117 1 1 2.31116 1 3.92857Z",
  fill: "white"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M3.92857 1.5C2.58731 1.5 1.5 2.58731 1.5 3.92857V52.25C1.5 53.5913 2.58731 54.6786 3.92857 54.6786H24.4286C24.9611 54.6786 25.3929 54.2468 25.3929 53.7143V41.2679C25.3929 39.3743 26.9279 37.8393 28.8214 37.8393H40.5357C41.0683 37.8393 41.5 37.4076 41.5 36.875V3.92857C41.5 2.58731 40.4127 1.5 39.0714 1.5H3.92857ZM0.5 3.92857C0.5 2.03502 2.03502 0.5 3.92857 0.5H39.0714C40.965 0.5 42.5 2.03502 42.5 3.92857V36.875C42.5 37.9598 41.6206 38.8393 40.5357 38.8393H28.8214C27.4802 38.8393 26.3929 39.9266 26.3929 41.2679V53.7143C26.3929 54.7991 25.5134 55.6786 24.4286 55.6786H3.92857C2.03502 55.6786 0.5 54.1435 0.5 52.25V3.92857Z",
  fill: "black"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  d: "M11.808 25.1535V28.8214H9.66309V18.4113H13.7242C14.5059 18.4113 15.1923 18.5543 15.7833 18.8402C16.3792 19.1262 16.8368 19.5338 17.1561 20.0629C17.4755 20.5872 17.6351 21.1854 17.6351 21.8575C17.6351 22.8775 17.2848 23.6831 16.5841 24.2741C15.8882 24.8604 14.923 25.1535 13.6884 25.1535H11.808ZM11.808 23.4161H13.7242C14.2914 23.4161 14.7228 23.2827 15.0183 23.0157C15.3186 22.7488 15.4688 22.3675 15.4688 21.8718C15.4688 21.3618 15.3186 20.9494 15.0183 20.6349C14.718 20.3203 14.3033 20.1582 13.7742 20.1487H11.808V23.4161Z",
  fill: "#D64200"
});

var _ref5 = /*#__PURE__*/React.createElement("path", {
  d: "M19.1152 28.8214V18.4113H22.3183C23.2335 18.4113 24.0509 18.6186 24.7707 19.0333C25.4952 19.4432 26.06 20.0295 26.4652 20.7921C26.8703 21.55 27.0729 22.4128 27.0729 23.3804V23.8594C27.0729 24.827 26.8727 25.6874 26.4723 26.4405C26.0767 27.1936 25.5166 27.7775 24.7921 28.1922C24.0676 28.6069 23.2502 28.8166 22.3397 28.8214H19.1152ZM21.2601 20.1487V27.0983H22.2968C23.1358 27.0983 23.7769 26.8242 24.2201 26.2761C24.6634 25.7279 24.8898 24.9438 24.8994 23.9238V23.3732C24.8994 22.3151 24.6801 21.5143 24.2416 20.9709C23.8031 20.4227 23.162 20.1487 22.3183 20.1487H21.2601Z",
  fill: "#D64200"
});

var _ref6 = /*#__PURE__*/React.createElement("path", {
  d: "M34.902 24.5673H30.7837V28.8214H28.6387V18.4113H35.4168V20.1487H30.7837V22.837H34.902V24.5673Z",
  fill: "#D64200"
});

var _ref7 = /*#__PURE__*/React.createElement("path", {
  d: "M41.8504 43.2317L30.2674 55.6421C29.814 56.1279 29 55.807 29 55.1425V43.4643C29 42.6556 29.6556 42 30.4643 42H41.3152C41.9553 42 42.2872 42.7637 41.8504 43.2317Z",
  fill: "#171717"
});

function SvgGetPdf(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 43,
    height: 56,
    viewBox: "0 0 43 56",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3, _ref4, _ref5, _ref6, _ref7);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGetPdf);
export default __webpack_public_path__ + "static/media/GetPdf.e9a877d7.svg";
export { ForwardRef as ReactComponent };